import RugCardPictureSource from './RugCardPictureSource'
export default RugCardPictureSource
